import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

// Componente para renderizar filas de salvaguardas
interface SafeguardRowProps {
  data: {
    id: number | null;
    name: string;
    [key: string]: any;
  };
  index: number;
  onEdit: (type: string, record: any) => void;
  onDelete: (type: string, record: any) => void;
  editingItem: { type: string; id: number | null };
  editedFormValues: any;
  setEditedFormValues: any;
  modifySafeguard: any;
  setEditingItem: any;
}

const SafeguardRow: React.FC<SafeguardRowProps> = ({
  data,
  index,
  onEdit,
  onDelete,
  editingItem,
  editedFormValues,
  setEditedFormValues,
  modifySafeguard,
  setEditingItem,
}) => {
  const { Text } = Typography;
  const displayName = `${index + 1}. ${data.name}`;

  if (editingItem.type === 'safeguard' && editingItem.id === data.id) {
    return (
      <div style={{ marginBottom: '8px', padding: '8px', border: '1px solid #f0f0f0' }}>
        <Text style={{ width: 200, display: 'block', marginBottom: 4 }}>{`${index + 1}.`}</Text>
        <TextArea
          value={editedFormValues.safeguard.name}
          onChange={(e) =>
            setEditedFormValues((prev: any) => ({
              ...prev,
              safeguard: { ...prev.safeguard, name: e.target.value, id: data.id },
            }))
          }
          onPressEnter={modifySafeguard}
          onBlur={modifySafeguard}
          autoFocus
          size='small'
          style={{ width: 200, display: 'block' }}
        />
      </div>
    );
  }
  return (
    <div style={{ marginBottom: '8px', padding: '8px', borderBottom: '1px solid #f0f0f0' }}>
      <Text style={{ width: 200, display: 'block' }}>{displayName}</Text>
      <span style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
        <Button icon={<EditOutlined />} onClick={() => onEdit('safeguard', data)} size='small' />
        <Button icon={<DeleteOutlined />} onClick={() => onDelete('safeguard', data)} size='small' danger />
      </span>
    </div>
  );
};

export default SafeguardRow;
